import ItemService from '@/services/ItemService'

// Slika artikla moze biti javni link na tudju stranicu ili datoteka koju je
// korisnik poslao na server, u folder svoje firme. U polju "ItemPictureN" u
// prvom slucaju stoji puna adresa, a u drugom samo naziv datoteke.
//
// Uploadana slika trazi prijavu, pa se ne moze staviti izravno u <img src>;
// dohvaca se s tokenom i vraca kao data URI. Dohvaceno se pamti, da se ista
// slika ne vuce vise puta u istoj listi.
const zapamceno = {}

export function jeVanjskiLink (vrijednost) {
  return /^(https?:)?\/\//i.test(String(vrijednost || '').trim())
}

export function kljucSlike (companyId, naziv) {
  return String(companyId) + '|' + String(naziv)
}

// Vraca ono sto ide u <img src>, ili prazno ako slike nema.
export async function dohvatiSliku (vrijednost, companyId) {
  const put = String(vrijednost || '').trim()
  if (put.length === 0) { return '' }
  if (jeVanjskiLink(put)) { return put }
  if (!companyId) { return '' }
  const kljuc = kljucSlike(companyId, put)
  if (zapamceno[kljuc] !== undefined) { return zapamceno[kljuc] }
  try {
    const odgovor = await ItemService.picture({ CompanyId: companyId, filename: put })
    const slika = odgovor.data && odgovor.data.data ? odgovor.data.data : ''
    zapamceno[kljuc] = slika
    return slika
  } catch (greska) {
    // Slika koja nedostaje ne smije srusiti popis - samo se ne prikaze.
    zapamceno[kljuc] = ''
    return ''
  }
}

// Posalji datoteku na server; vraca naziv pod kojim je spremljena.
export async function posaljiSliku (datoteka, companyId) {
  const fd = new FormData()
  fd.append('companyId', companyId)
  fd.append('newId', Math.floor(Math.random() * 800000) + 100000)
  fd.append('myFile', datoteka, datoteka.name)
  const odgovor = await ItemService.uploadPicture(fd)
  return odgovor.data && odgovor.data.filename ? odgovor.data.filename : ''
}

export function zaboraviSliku (companyId, naziv) {
  delete zapamceno[kljucSlike(companyId, naziv)]
}

// Koja se od sedam slika uzima: zadana ako je postavljena, inace prva
// popunjena. Isto vrijedi za artikl iz sifrarnika i za stavku dokumenta - oba
// imaju ista polja.
export function odaberiSliku (zapis) {
  if (!zapis) { return '' }
  const zadana = parseInt(zapis.ItemDefaultPicture, 10)
  if (zadana >= 1 && zadana <= 7) {
    const put = zapis['ItemPicture' + zadana]
    if (put && String(put).trim().length > 0) { return String(put).trim() }
  }
  for (let i = 1; i <= 7; i++) {
    const put = zapis['ItemPicture' + i]
    if (put && String(put).trim().length > 0) { return String(put).trim() }
  }
  return ''
}

// Najveca stranica slike u ispisu. Slika se u dokumentu prikazuje oko 110 pt
// (nesto ispod 4 cm), pa vise od ovoga oko se ne vidi, a PDF bi bio nekoliko
// puta veci - a racun i ponuda se salju e-mailom.
const NAJVECA_STRANICA = 500

// Smanji sliku na razumnu velicinu za ispis. Ako smanjivanje ne uspije (npr.
// preglednik ne moze procitati sliku), vraca se original - bolje velika slika
// nego nikakva.
function smanjiSliku (dataUri) {
  return new Promise((rijesi) => {
    try {
      const slika = new Image()
      slika.onload = () => {
        try {
          const najveca = Math.max(slika.width, slika.height)
          if (!najveca || najveca <= NAJVECA_STRANICA) { return rijesi(dataUri) }
          const omjer = NAJVECA_STRANICA / najveca
          const platno = document.createElement('canvas')
          platno.width = Math.round(slika.width * omjer)
          platno.height = Math.round(slika.height * omjer)
          const crtac = platno.getContext('2d')
          crtac.drawImage(slika, 0, 0, platno.width, platno.height)
          // PNG ostaje PNG zbog prozirnosti; JPEG se sprema kao JPEG.
          const jePng = dataUri.indexOf('data:image/png') === 0
          rijesi(jePng ? platno.toDataURL('image/png') : platno.toDataURL('image/jpeg', 0.82))
        } catch (greska) {
          rijesi(dataUri)
        }
      }
      slika.onerror = () => rijesi(dataUri)
      slika.src = dataUri
    } catch (greska) {
      rijesi(dataUri)
    }
  })
}

// Slika za ispis u PDF.
//
// pdfmake ne dohvaca slike sam i prima samo data URI, i to JPEG ili PNG.
// Uploadana slika vec dolazi kao data URI; javni link treba dohvatiti i
// pretvoriti. Sve sto se ne moze pretvoriti vraca prazno - ispis se tada
// napravi bez te slike, jer neispravna slika rusi cijeli dokument.
export async function slikaZaPdf (vrijednost, companyId) {
  const izvor = await dohvatiSliku(vrijednost, companyId)
  if (!izvor) { return '' }
  if (izvor.indexOf('data:image/jpeg') === 0 || izvor.indexOf('data:image/png') === 0) {
    return await smanjiSliku(izvor)
  }
  // Neki drugi zapis slike (npr. webp ili svg) pdfmake ne zna procitati.
  if (izvor.indexOf('data:') === 0) { return '' }

  // Javni link: preglednik ne smije procitati sliku s tudje adrese (CORS), pa
  // je dohvaca nas posluzitelj i vraca kao data URI.
  const kljuc = kljucSlike('pdf', izvor)
  if (zapamceno[kljuc] !== undefined) { return zapamceno[kljuc] }
  try {
    const odgovor = await ItemService.fetchPicture({ url: izvor })
    const dohvaceno = odgovor.data && odgovor.data.data ? odgovor.data.data : ''
    const slika = dohvaceno ? await smanjiSliku(dohvaceno) : ''
    zapamceno[kljuc] = slika
    return slika
  } catch (greska) {
    // Nedostupna ili neprikladna slika ne smije srusiti ispis.
    zapamceno[kljuc] = ''
    return ''
  }
}
